import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "src/environments/environment";
import { Format } from "../models/format";

@Injectable({
  providedIn: "root"
})
export class FormatService {

    private createHeader() {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          })
        };
        return httpOptions;
      }

    constructor(private httpClient: HttpClient) {}

    getFormats() : Observable<Format[]> {
        return this.httpClient.get<Format[]>(`${environment.ApiEndpoint}/Format/GetFormats`, this.createHeader());
    }
}
